import { uiGetMediaQuery } from '../media';
import { UIMediaQuery } from '../types';
import { UIView, UIViewSpec } from '../view';

export class UIMediaBranch extends UIView {
    constructor(query: UIMediaQuery, true_content: () => UIViewSpec, false_content: () => UIViewSpec) {
        const match = uiGetMediaQuery(query);
        let matches = match.matches;

        super((matches ? true_content() : false_content()).ui_elem);

        match.addEventListener('change', e => {
            if(matches == e.matches) return;
            matches = e.matches;
            this.reconstruct((matches ? true_content() : false_content()).ui_elem);
        })
    }
}
